import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { Grid } from '@alfa-bank/site-grid-universal';
import { HintDesktop as Hint } from '@alfa-bank/site-invest-emitents-common/components/hint-desktop';
import { InformationCircleSIcon } from '@alfalab/icons-glyph/InformationCircleSIcon';

import { defaultDividendBannerTexts } from '../../../configs';
import type { IDividendCellProps } from '../models';
import styles from '../styles.css';
import { getDividendsInfo } from '../../../helpers';

export const PayDateDesktop: FC<IDividendCellProps> = ({ asset, tooltipHint }) => {
    const { dividendPayDate, payDateLong } = getDividendsInfo(asset);

    if (!dividendPayDate || !payDateLong) {
        return null;
    }

    const { title } = defaultDividendBannerTexts.cells.payDate;

    return (
        <>
            <Grid colAutoWidth collapse justify="start">
                <Text styler={{ margin: 0, marginTop: 0 }} tag="div" view="accent-primary-medium">
                    {payDateLong}
                    <Hint className={cn(styles.external, styles.hint)} content={tooltipHint}>
                        <InformationCircleSIcon
                            className={cn(styles.external, styles.iconFill)}
                            fill="#B8B9C0"
                        />
                    </Hint>
                </Text>
            </Grid>

            <Grid
                alignment="center"
                colAutoWidth
                collapse
                justify="start"
                styler={{ marginTop: 4 }}
            >
                <Text
                    className={cn(styles.external, styles.text)}
                    styler={{ margin: 0 }}
                    view="primary-small"
                >
                    {title}
                </Text>
            </Grid>
        </>
    );
};
